import { useCallback } from 'react';
import { openExternalURL } from 'shared/helpers/URLHelpers';
import {
  FeatureToggles,
  useCarrierSettingsMutation,
} from 'shared/settings/CarrierSettingsAPI';
import { isFlagEnabled, useFlag } from 'shared/settings/FeatureToggles';
import { getBackURL } from 'shared/ui/BackButton';

const TMS_HOME_URL = '/tms/home';
const TMS_LOADS_URL = '/tms/loads';

function getTMSLandingURL(features: null | FeatureToggles) {
  return isFlagEnabled(features, 'ctms_homepage')
    ? TMS_HOME_URL
    : TMS_LOADS_URL;
}

export function useLandingPath() {
  return useFlag('ctms_homepage') ? '/home' : '/loads';
}

export function useTMSLandingURL() {
  return useFlag('ctms_homepage') ? TMS_HOME_URL : TMS_LOADS_URL;
}

export function useRedirectToTMSLanding() {
  const { mutate, isPending } = useCarrierSettingsMutation({
    onSuccess: ({ data }) => {
      redirectToURL(getTMSLandingURL(data.features));
    },
    onError: () => {
      redirectToURL(TMS_LOADS_URL);
    },
  });

  const redirectToTMSLanding = useCallback(() => {
    mutate(undefined);
  }, [mutate]);

  return { redirectToTMSLanding, isPending };
}

export function redirectToURL(url: string) {
  openExternalURL(getBackURL(window.location.search, url));
}
